import Vue from "vue/dist/vue.esm";

const elements = document.querySelectorAll(".modalOverlay");

if (elements) {
  elements.forEach(element => {
    new Vue({
      el: `#${element.id}`,
      data: {
        isVideo: true,
        modalActive: false,
        htmlElement: null
      },
      methods: {
        openModal() {
          const iframe = this.$refs.modalContent.querySelector("iframe");

          if (iframe && this.isVideo && !iframe.src) {
            iframe.src = iframe.getAttribute("data-src");
          }

          this.modalActive = true;
          this.htmlElement.classList.add("is-clipped");
        },
        closeModal() {
          this.modalActive = false;
          this.htmlElement.classList.remove("is-clipped");
          if (this.isVideo) {
            this.$refs.modalContent
              .querySelector("iframe")
              .contentWindow.postMessage(
                '{"event":"command","func":"stopVideo","args":""}',
                "*"
              );
          }
        },
        escCloseModal(event) {
          if (event.keyCode === 27) {
            this.closeModal();
          }
        }
      },
      mounted() {
        window.addEventListener("keyup", this.escCloseModal);
        this.htmlElement = document.querySelector("html");
      },
      destroyed() {
        window.removeEventListener("keyup", this.escCloseModal);
      }
    });
  });
}
